/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popBioMatrixScan.vue?vue&type=template&id=195f857e&scoped=true"
import script from "./popBioMatrixScan.vue?vue&type=script&lang=js"
export * from "./popBioMatrixScan.vue?vue&type=script&lang=js"
import style0 from "./popBioMatrixScan.vue?vue&type=style&index=0&id=195f857e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f857e",
  null
  
)

export default component.exports